"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isKnownLocale = void 0;
// local
const enums_1 = require("./enums");
// The valid actions indexed by type
const VALID_LOCALES = {};
Object.values(enums_1.LanguageKey).forEach((value) => {
    VALID_LOCALES[value] = value;
});
/**
 * Test if a string is a locale that we support
 *
 * @param locale - The locale to test
 * @returns True if a valid locale
 */
function isKnownLocale(locale) {
    return !!locale && typeof locale === 'string' && locale in VALID_LOCALES;
}
exports.isKnownLocale = isKnownLocale;
//# sourceMappingURL=typeGuards.js.map